<template>
	<div class="trace-window shadow" v-if="traceWindowShow">

		<div class="container pt-2">
			<button class="btn btn-sm btn-light d-flex align-items-center position-absolute border border-dark py-1" style="right: 15px; z-index: 9992" @click="closeTrace"><i class="fa fa-times"></i></button>
			<div class="row">
				<div class="col-6">
					<label for="start" class="label">Trace date start</label>
					<date-picker id="start" v-model="date_start" type="datetime" format="YYYY-DD-MM HH:mm" :time-picker-options="timePickerOptions" lang="en"></date-picker>
				</div>
				<div class="col-6">
					<label for="end" class="label">Trace data stop</label>
					<date-picker id="end" v-model="date_end" type="datetime" format="YYYY-DD-MM HH:mm" :time-picker-options="timePickerOptions" lang="en"></date-picker>
				</div>
			</div>
			<div class="row bottom-controls">
				<div class="col-4">
					<div class="checkbox">
						<label for="fade" class="label">
							<input type="checkbox" id="fade" v-model="pathFading">
							Fading
						</label>
					</div>
				</div>
				<div class="col-4">
					<label for="split" class="label">
						<input type="checkbox" id="split" v-model="splitByFloor">
						Split by floor
					</label>
				</div>
				<div class="col-4">
					<input type="color" id="pathColor" v-model="pathColor">
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import eventHub from '../../plugins/eventHub';
	import {mapState} from 'vuex'
	import DatePicker from 'vue2-datepicker';
	import * as randomPoint from 'random-points-on-polygon';
	import moment from 'moment';

	export default {
		name: 'Trace',
		data() {
			return {
				traceWindowShow: false,
				date_start: '',
				date_end: '',
				timePickerOptions:{
					start: '00:00',
					step: '00:30',
					end: '23:30'
				},
				worker_id: null,
				log: [],
				pathFading: false,
				splitByFloor: false,
				pathColor: '#f00000'
			}
		},
		computed: {
			...mapState([
				'time_to',
				'muster ',
				'filteredWorkers',
				'load',
				'floor_level',
				'clock',
				'time',
				'path_features',
				'features',
				'workers',
				'speed',
				'watcher',
				"position",
				'paths',
				'zones'
			]),
			map() {
				return this.$store.state.map.map
			},
			traceLayer: {
				get() {
					return this.$store.state.map.traceLayer;
				},
				set(value) {
					this.$store.commit("setState", ["map.traceLayer", value]);
				}
			},
		},
		watch: {
			pathColor() {
				this.updateStyle();
			},
			pathFading() {
				this.updateStyle();
			},
			date_start() {
				this.filterLog();
				this.updatePath();
			},
			date_end() {
				this.filterLog();
				this.updatePath();
			},
			floor_level() {
				this.updateStyle();
			},
			splitByFloor() {
				this.updateStyle();
			}
		},
		mounted() {
			this.traceLayer = new ol.source.Vector({
				wrapX: false,
				updateWhileAnimating: false,
				updateWhileInteracting: false
			});

			var layer = new ol.layer.Vector({
				source: this.traceLayer,
				style: this.getStyle,
				zIndex: 3
			});

			this.map.addLayer(layer);

			eventHub.$on('show-trace-window', (worker_id) => {
				this.traceWindowShow = true;//!this.traceWindowShow;

				if (this.traceWindowShow) {

					this.worker = this.workers[worker_id];
					let log = this.position[worker_id];

					let first_day_log = log[Object.keys(log)[0]];

					let days = Object.keys(log);
					let last_day_log = [];
					let i = 1;
					while (last_day_log.length == 0 && days.length >= i) {
						let last_day = days[days.length - i];
						last_day_log = log[last_day];
						i++;
					}

					if (first_day_log.length) this.date_start = this.$datetime.convertToUTC(first_day_log[0].clock);
					if (last_day_log.length) this.date_end = this.$datetime.convertToUTC(last_day_log[last_day_log.length - 1].clock);

				} else {
					this.removePath();
				}
			});
			eventHub.$on('hide-trace-window', () => {
				this.traceWindowShow = false;
				this.removePath();
			})
		},
		methods: {
			closeTrace() {
				eventHub.$emit('hide-trace-window');
			},
			filterLog() {
				let log = [];
				for (let day in this.position[this.worker.id]) {
					let dday = this.$datetime.day(0, day);
					if (dday >= this.date_start.getDate() && dday <= this.date_end.getDate()) {
						this.position[this.worker.id][day].forEach(item => {
							if (this.$datetime.convertToUTC(item.clock) >= this.date_start && this.$datetime.convertToUTC(item.clock) <= this.date_end) log.push(item);
							// log.push(item);
						})
					}
				}
				this.log = log;
			},
			addPath() {

				let dots = [];
				let dot;
				this.log.forEach(item =>  {
					dot = new ol.Feature({
						geometry: new ol.geom.Point(item.coordinates),
						name: 'DotPosition',
					});
					dot.floor_level = item.floor_level;
					dots.push(dot);
				});
				this.traceLayer.addFeatures(dots);
				this.updateStyle();
			},
			getStyle: function (feature, resolution) {

				if (this.splitByFloor && this.floor_lever != '*' && feature.floor_level != this.floor_level) {
					return new ol.style.Style(null);
				}

				let styles = [];
				let style = new ol.style.Style({
					image: new ol.style.Circle({
						radius: 7,
						fill: new ol.style.Fill({color: this.getColor()}),
						stroke: new ol.style.Stroke({
							color: this.getColor(),
							width: 2
						})
					})
				});
				styles.push(style);

				return styles;
			},
			getColor() {
				let newColor;
				if (this.pathFading) {
					newColor = `rgba(${this.hexToRgb(this.pathColor).r}, ${this.hexToRgb(this.pathColor).g}, ${this.hexToRgb(this.pathColor).b}, 0.2)`;
				} else {
					newColor = this.pathColor;
				}
				return newColor;
			},
			getFeatureByName(name) {
				let features = this.traceLayer.getFeatures();
				return features.filter(item => item.getProperties().name === name);
			},
			hexToRgb(hex) {
				let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : null;
			},
			updateStyle() {
				let features = this.getFeatureByName('DotPosition');
				for (let feature of features) {
					feature.setStyle(this.getStyle(feature));
				}
			},
			removePath() {
				let features = this.getFeatureByName('DotPosition');
				for (let feature of features) {
					this.traceLayer.removeFeature(feature);
				}
			},
			updatePath() {
				this.removePath();
				this.addPath();
			}
		},
		components: {DatePicker}

	}
</script>

<style scoped>
	.trace-window {
		position: absolute;
		padding: 0;
		top: 0;
		right: 200px;
		width: 480px;
		height: 125px;
		background: white;
		z-index: 99999;
	}
	.trace-input-date {
		width: 100%;
	}
	.label {
		font-size: 12px;
		font-weight: bold;
	}
	input[type="color"] {
		-webkit-appearance: none;
		border: none;
		width: 50px;
		height: 25px;
	}
	input[type="color"]::-webkit-color-swatch-wrapper {
		padding: 0;
	}
	input[type="color"]::-webkit-color-swatch {
		border: none;
	}
	.bottom-controls {
		padding-top: 10px;
	}
</style>
